module.exports = __webpack_public_path__ + "img/home-emergency.5a7ad8ba.png";